const styleLoaders = {
  'initial-face': () => import('@dicebear/styles/initial-face.json'),
  'fun-emoji': () => import('@dicebear/styles/fun-emoji.json'),
  'voxel-art': () => import('@dicebear/styles/voxel-art.json'),
  lorelei: () => import('@dicebear/styles/lorelei.json'),
  notionists: () => import('@dicebear/styles/notionists.json'),
  critters: () => import('@dicebear/styles/critters.json'),
  shapes: () => import('@dicebear/styles/shapes.json'),
};
export const AVATAR_STYLES = Object.keys(styleLoaders);
export const createAvatarChoices = async (styleId, page = 0) => {
  if (!styleLoaders[styleId]) throw new Error('Unknown avatar style');
  const [{ Avatar, Style }, definition] = await Promise.all([
    import('@dicebear/core'),
    styleLoaders[styleId](),
  ]);
  const style = new Style(definition.default);
  return Array.from({ length: 24 }, (_, index) => {
    const id = `${styleId}-${page * 24 + index}`;
    const avatar = new Avatar(style, {
      seed: `talkvia-gallery-${id}`,
      size: 256,
      backgroundColor: [
        'e0e7ff',
        'd1fae5',
        'fef3c7',
        'ffe4e6',
        'e0f2fe',
        'f3e8ff',
      ],
    });
    return { id, url: avatar.toDataUri() };
  });
};

// Persist a normal PNG through the existing avatar upload flow.
export const avatarToUpload = avatar =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onerror = () => reject(new Error('Unable to render avatar'));
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 256;
        canvas.height = 256;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Canvas is unavailable');
        context.drawImage(image, 0, 0, 256, 256);
        const url = canvas.toDataURL('image/png');
        canvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('Unable to encode avatar'));
            return;
          }
          resolve({
            file: new File([blob], `avatar-${avatar.id}.png`, {
              type: 'image/png',
            }),
            url,
          });
        }, 'image/png');
      } catch (error) {
        reject(error);
      }
    };
    image.src = avatar.url;
  });
